<template>
	<div class="row">
		<div class="col-lg-8 offset-lg-2">
			<div class="common_author_form">
				<form class="register_agency" id="main_author_form" @submit.prevent="registerAgency" ref="saveAgency"
					@input="validateRecaptcha">
					<div class="row">
						<div class="form-group col-lg-12">
							<input type="text" class="form-control" :placeholder="$t('commercial_name')"
								v-model="form._name" id="_name" required />
						</div>
						<div class="form-group">
							<input type="text" class="form-control" :placeholder="$t('company_name')" required
								v-model="form._company_name" id="_company_name" />
						</div>
						<div class="form-group col-lg-6">
							<v-select class="form-control" id="_type_document_id" v-model="_documentSelected"
								label="text" :options="type_document" :filterable="true"
								:placeholder="$t('type_person')" required></v-select>
						</div>
						<div class="form-group col-lg-6">
							<input type="number" class="form-control" :placeholder="$t('identification_number')"
								required v-model="form._document" id="_document" />
						</div>
						<div class="form-group col-lg-6">
							<input type="text" class="form-control" :placeholder="$t('legal_representative')" required
								v-model="form._legal_representative" id="_legal_representative" @input="formatNumber" />
						</div>
						<div class="form-group col-lg-6 d-flex flex-column text-start">
							<input type="email" class="form-control" :placeholder="$t('email')" required
								v-model="form._email" id="_email" />
							<small><small class="left text-muted d-block">{{ $t('credentials_sent_message')
							}}</small></small>
						</div>
						<div class="form-group col-lg-6">
							<v-select class="form-control" v-model="citySelected" label="text" :options="cities"
								id="_city_id" :filterable="true" :placeholder="$t('city')" required></v-select>
						</div>

						<div class="form-group form-group col-lg-6">
							<input type="text" class="form-control" :placeholder="$t('address')" required
								v-model="form._address" id="_address" />
						</div>

						<div class="form-group col-lg-6">
							<input type="number" class="form-control" :placeholder="$t('phone')" v-model="form._phone"
								id="_phone" />
						</div>
						<div class="form-group col-lg-6">
							<input type="text" class="form-control" :placeholder="$t('contact_link')"
								v-model="form._contact_link" id="_contact_link" />
						</div>
						<div class="common_author_heading">
							<h2>{{ $t("owner_information") }}</h2>
							<br />
						</div>

						<div class="form-group col-lg-12">
							<input type="text" class="form-control" :placeholder="$t('full_name')" required
								v-model="form.name" id="name" />
						</div>
						<div class="form-group col-lg-6">
							<v-select class="form-control" id="type_document_id" v-model="documentSelected" label="text"
								:options="type_document" :filterable="true" :placeholder="$t('type_person')"
								required></v-select>
						</div>
						<div class="form-group col-lg-6">
							<input type="number" class="form-control" :placeholder="$t('identification_number')"
								required v-model="form.document" id="document" />
						</div>
						<div class="form-group col-lg-6 d-flex flex-column text-start">
							<input type="email" class="form-control" :placeholder="$t('email')" required
								v-model="form.email" autocomplete="true" id="email" />
							<small><small class="left text-muted d-block">{{ $t('credentials_sent_message')
							}}</small></small>
						</div>
						<div class="form-group col-lg-6">
							<input type="number" class="form-control" :placeholder="$t('phone')"
								v-model="form.main_phone" id="main_phone" required />
						</div>
						<div class="col-sm-12 col-md-12 col-lg-12">
							<div class="form-check px-0 d-flex align-items-start">
								<label class="form-check-label d-flex align-items-start m-0">
									<input class="form-check-input mx-2" type="checkbox" v-model="form.acceptTerms" />
									{{ $t("i_accept_terms_and_conditions") }}

									<a class="btn btn-link mx-2 p-0 small ml-2 text-info text-decoration-underline"
										href="#" @click.stop.prevent="openInNewTab">
										{{ $t('view') }}
									</a>
								</label>
							</div>
						</div>
					</div>
					<div class="common_form_submit">
						<button type="submit" class="btn btn_theme btn_md" :disabled="loading">
							<span v-if="loading">
								<i class="fa fa-spinner fa-spin"></i> {{ $t("saving") }}...
							</span>
							<span v-else>
								{{ $t("register") }}
							</span>
						</button>
					</div>
				</form>
			</div>
		</div>
	</div>
</template>

<script>
import axios from "axios";
import { mapActions } from "vuex";
import {
	API_BASE_URL,
	SAVE_AGENCY,
	TYPE_DOCUMENT_API,
	CITY_API,
} from "@/api-config";
import Swal from "sweetalert2";
import { useReCaptcha } from "vue-recaptcha-v3";

export default {
	name: "CommonAuthorSix",
	data() {
		return {
			type_document: [],
			cities: [],
			documentSelected: null,
			_documentSelected: null,
			citySelected: null,
			form: {
				_name: "",
				_company_name: "",
				_type_document_id: "",
				_document: "",
				_legal_representative: "",
				_city_id: "",
				_address: "",
				_email: "",
				_phone: "",
				_contact_link: "",
				name: "",
				type_document_id: "",
				document: "",
				main_phone: "",
				email: "",
				acceptTerms: false,
			},
			recaptchaVerified: false,
			recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
			loading: false,
		};
	},
	setup() {
		const { executeRecaptcha } = useReCaptcha();
		return { executeRecaptcha };
	},

	async mounted() {
		this.getTypeDocument();
		this.getCities();
	},

	methods: {
		...mapActions("form", ["updateError"]),

		async validateRecaptcha() {
			if (this.recaptchaVerified) {
				return;
			}
			try {

				const token = await this.executeRecaptcha("common_author_form");
				if (token) {
					this.recaptchaVerified = true;
				} else {
					this.recaptchaVerified = false;
				}
			} catch (error) {
				console.error("reCAPTCHA failed", error);
				this.recaptchaVerified = false;
			}
		},

		getTypeDocument() {
			axios
				.get(`${API_BASE_URL}${TYPE_DOCUMENT_API}`)
				.then((response) => {
					this.type_document = response.data.results;
				})
				.catch((error) => {
					console.log(error);
				});
		},

		getCities() {
			axios
				.get(`${API_BASE_URL}${CITY_API}`)
				.then((response) => {
					this.cities = response.data.results;
				})
				.catch((error) => {
					console.log(error);
				});
		},


		showAlert(message, type) {
			Swal.fire({
				icon: type,
				title: type === "success" ? "Éxito" : "Error",
				text: message,
			}).then(() => {
				this.updateError({ status: false, message: "" });
			});
		},

		validateForm() {
			if (!this.form.acceptTerms) {
				return this.$t("please_accept_terms_and_conditions");
			}
			return null;
		},

		resetForm() {
			this.form = {
				_name: "",
				_company_name: "",
				_type_document_id: "",
				_document: "",
				_legal_representative: "",
				_city_id: "",
				_address: "",
				_email: "",
				_phone: "",
				_contact_link: "",
				name: "",
				type_document_id: "",
				document: "",
				main_phone: "",
				email: "",
				acceptTerms: false,
			};

			this.documentSelected = null;
			this._documentSelected = null;
			this.citySelected = null;

		},

		async registerAgency() {
			if (!this.recaptchaVerified) {
				this.showAlert(this.$t("please_resolve_captcha"), "error");
				return;
			}

			const validationError = this.validateForm();
			if (validationError) {
				this.showAlert(validationError, "error");
				return;
			}

			const formData = {
				...this.form,
				_city_id: this.citySelected?.id,
				_type_document_id: this._documentSelected?.id,
				type_document_id: this.documentSelected?.id,
			};

			this.deleteMessageError();

			this.loading = true;

			try {
				const response = await axios.post(
					`${API_BASE_URL}${SAVE_AGENCY}`,
					formData
				);

				if (response.data && response.data.message) {
					this.showAlert(response.data.message, "success");
					this.resetForm();
				}
			} catch (error) {
				console.error(error);
				if (
					error.response &&
					error.response.data &&
					error.response.data.message
				) {
					this.showAlert(error.response.data.message, "error");
					
					this.showFieldErrors(error.response.data.errors);
				} else {
					this.showAlert("Error desconocido", "error");
				}
			} finally {
				this.loading = false;
			}
		},

		deleteMessageError() {
			const errorMessages = document.querySelectorAll('.input-error-message');
			errorMessages.forEach(el => {
				el.remove();
			});
			const allElements = document.querySelectorAll('*');
			const redBorderElements = Array.from(allElements).filter(el => el.style.border === '1px solid red');
			redBorderElements.forEach(el => {
				el.style.border = '';
			});

		},
		showFieldErrors(errors) {

			Object.keys(errors).forEach((key) => {
				const form = document.getElementsByClassName('register_agency')[0];
				const input = form.querySelector(`[id="${CSS.escape(key)}"]`);
				console.log(33333, input);
				if (input) {
					// Aplica el borde rojo
					input.style.border = "1px solid red";

					// Elimina cualquier mensaje de error anterior
					const existingError = input.parentNode.querySelector('.input-error-message');
					if (existingError) {
						existingError.remove();
					}

					// Crea y muestra el mensaje de error
					const errorMessage = document.createElement('div');
					errorMessage.textContent = errors[key][0];
					errorMessage.classList.add('input-error-message');
					errorMessage.style.color = "red";
					errorMessage.style.fontSize = "0.9em";
					errorMessage.style.marginTop = "5px";

					input.parentNode.insertBefore(errorMessage, input.nextSibling);

					// Limpia el borde rojo cuando el usuario hace focus
					input.addEventListener('focus', function clearError() {
						input.style.border = "";
						errorMessage.remove();
						input.removeEventListener('focus', clearError);
					});
				}
			});

		},
		openInNewTab() {
			const url = this.$router.resolve({
				name: "terms-service",
			}).href;

			window.open(url, "_blank", "noopener,noreferrer");
		},
	},
};
</script>
